import { Component, Input } from '@angular/core';
import { App, LoadingController, NavController, Events } from 'ionic-angular';
import { EventProvider } from '../../providers/event/event';
import { TranslateService } from '@ngx-translate/core';
import { ResultProvider } from '../../providers/result/result';
import { SessionProvider } from '../../providers/session/session';
import { UserProvider } from '../../providers/user/user';
import { ResultDetailsCommentPage } from '../../pages/results/result-details/result-details-comment/result-details-comment';
import { ResultDetailsThumbupPage } from '../../pages/results/result-details/result-details-thumbup/result-details-thumbup';
import { LoginPage } from '../../pages/login/login/login';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { ThemeMode } from '../../providers/dark-mode/dark-mode';


/**
 * Generated class for the MysportIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
    selector: 'result-menu-toolbar',
    templateUrl: 'result-menu-toolbar.html'
})
export class ResultMenuToolbarComponent {

    @Input("result")
    result: any;

    stateThumb: string = "gray";
    stateComment: string = "gray";
    resultDetails: any;
    congrats: any[] = [];

    pagerComment: Pager = { page: null, start: null, limit: null };
    pagerCongrats: Pager = { page: null, start: null, limit: null };
    // mode
    themeMode

    constructor(
        public app: App,
        private resultService: ResultProvider,
        private sessionService: SessionProvider,
        private userService: UserProvider,
        private eventsListener: Events,
        private detectorProvider: AppDetectorProvider,
        private navCtrl: NavController
    ) {
        console.log("RESULT-MENU-TOOLBAR COMPONENT CONSTRUCTOR!");

        this.eventsListener.subscribe('toolbar:update', () => {
            this.preloadData();
        });
    }

    ngOnInit() {
        this.preloadData();
        this.themeMode =  JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
        if(this.themeMode=='darkMode'){
            this.stateComment = "white"
            this.stateThumb = "white"
        }
    }

    preloadData() {
        Promise.all([this.getResultDetails(), this.getFans()]).then((data) => {
            this.resultDetails = data[0];
            this.congrats = data[1];

            this.checkFan();
        })
    }
//
    getResultDetails():Promise<any>{
        if(!this.result) return;
        return new Promise<any>((resolve, reject)=>{
            this.resultService.getResult(this.result.id, this.result.cid).then(data=>{
                this.resultDetails = data;
                resolve(data)
            })
        
        })
    }

    getFans(): Promise<any> {
        if (!this.result) return;
        return new Promise<any>((resolve, reject) => {
            this.resultService.getFans(this.result.id, this.pagerCongrats.page, this.pagerCongrats.start, this.pagerCongrats.limit).then(data => {
                this.congrats = data;
                resolve(data);
            });
        });
    }

    checkFan() {
        if (this.sessionService.isLoged) {
            this.userService.getPrivateProfile().then(profile => {
                let isFan = this.isFan(profile);
                if (isFan) this.onToogleThumbDOM();
            })
        } else {
            if (this.stateThumb == "blue") this.onToogleThumbDOM();
        }
    }

    isFan(profile) {
        if (typeof this.congrats === "undefined") return false;

        for (let i = 0; i < this.congrats.length; i++) {
            if (this.congrats[i].usrId == profile.id) {
                return true
            }
        }
        return false;
    }


    addFan() {
        this.resultService.congrat(this.result.id).then(data => {
            console.log('data: ', data);
            this.getFans().then(() => {
                this.onToogleThumbDOM();
            });
        });
    }

    removeFan() {
        this.resultService.removeCongrat(this.result.id).then(data => {
            this.getFans().then(() => {
                this.onToogleThumbDOM();
            });
        });
    }

    onToogleThumb() {
        let profileRequired = this.detectorProvider.isHellaApp() ? false : true;
        if (!this.sessionService.isLoged) {
            this.navCtrl.push(LoginPage, { isRootNav: false });
            return;
        }
        this.sessionService.getToken(false, profileRequired).then(token => {
            (this.stateThumb == "gray" || this.stateThumb=="white") ? this.addFan() : this.removeFan();
        });
    }

    onToogleThumbDOM() {
        // const icon = document.querySelector('div#thumpup-icon.icon-circle.centered.thumb-circle')[0];
        this.stateThumb = this.getColor();
        // icon.style.backgroundColor =
        // icon.style.backgroundColor = "white";
        // icon.style.borderColor = (this.stateThumb == "blue") ? "white" : "gray";
    }

    getBgColor() {
        return (this.stateThumb !== "gray") ? "#" + this.stateThumb + " !important" : "white";
    }

    getColor() {
        if (this.stateThumb !== "gray" && this.stateThumb !=='white') {
            return this.themeMode==="darkMode"? "white":"gray"
        } else {
            if (this.detectorProvider.isForestApp()) {
                if(this.themeMode=="darkMode")return "71af4b"
                return "28564b";
            }
            if(this.detectorProvider.isLeaderBoardApp()){
                if(this.themeMode=="darkMode")return "4285F4"
                return "294F94";
            }
        }

        return "294F94";
    }

    getFrColor() {
        if(this.themeMode=="darkMode") return (this.stateThumb !== "white") ? "#" + this.stateThumb : "white";
        return (this.stateThumb !== "gray") ? "#" + this.stateThumb : "gray";
    }

    onToogleComment() { }

    onPageLoad(str, event) {
        let page = (str.includes('comment')) ? ResultDetailsCommentPage : ResultDetailsThumbupPage;

        // this.sessionService.getLoginStatus().then(status => {
        //     if (status) this.navCtrl.push(page, { result: this.result });
        //     else {
        //         new Promise((resolve, reject) => {
        //             if (this.detectorProvider.isHellaApp()) {
        //                 this.sessionService.getToken(false, false).then(token => {
        //                     this.app.getRootNav().push(IdRegistrationPage);
        //                 });
        //             } else {
        //                 this.app.getRootNav().push(LoginPage, { resolve: resolve })
        //             }
        //         }).then((status) => {
        // if (status) (this.app.getActiveNav() as NavController).push(page, { result: this.result });
        this.navCtrl.push(page, { result: this.result });
        //         });
        //     }
        // });
    }

}


export interface Pager {
    page: any;
    start: any;
    limit: any;
}


// WEBPACK FOOTER //
// /src/components/result-menu-toolbar/result-menu-toolbar.ts